import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import ProtectedModuleRoute from '../../Router/ProtectedModuleRouter';
import ListVoucher from './List';
import AddVoucher from './Add';
import EditVoucher from './Edit';

class VoucherPage extends Component {
    render() {
        return (
            <Switch>
                <ProtectedModuleRoute exact path="/admin/vouchers" component={ListVoucher} />
                <ProtectedModuleRoute exact path="/admin/vouchers/add" component={AddVoucher} />
                <ProtectedModuleRoute exact path="/admin/vouchers/edit/:id" component={EditVoucher} />
            </Switch>
        )
    }
};

export default VoucherPage;